import React from 'react';

const SmallInfoIcon = ({
  color = 'currentColor',
  className = '',
  width = '20',
  height = '20',
}) => {
  return (
    <svg
      data-testid="info-icon"
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.895431 19.1046 0 18 0H2ZM8.69995 5.3C8.69995 4.6 9.29995 4 9.99995 4C10.7 4 11.3 4.6 11.3 5.3C11.3 6 10.7 6.6 9.99995 6.6C9.29995 6.6 8.69995 6 8.69995 5.3ZM8 9C8 9.6 8.4 10 9 10V15C9 15.6 9.4 16 10 16C10.6 16 11 15.6 11 15V9C11 8.4 10.6 8 10 8H9C8.4 8 8 8.4 8 9Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};

export default SmallInfoIcon;
